<script setup lang="ts">
import type { Component } from "vue";
import { cn } from "~/lib/utils";

defineProps<{
  icon: Component;
  title: string;
  ctaText?: string;
  ctaLink?: string;
}>();
</script>

<template>
  <div :class="cn('bg-primary text-white py-12 print:hidden', $attrs['class'])">
    <div class="main-content flex flex-col md:flex-row justify-between items-start md:items-center gap-5">
      <div>
        <h2 class="flex flex-col gap-3 md:gap-2 items-start md:flex-row md:items-center text-4xl font-extrabold mb-5"><component :is="icon" class="w-12 h-12"></component>{{ title }}</h2>
        <slot></slot>
      </div>
      <Button class="border border-white" size="lg" as-child v-if="ctaLink && ctaText">
        <NuxtLink :href="ctaLink">{{ ctaText }}</NuxtLink>
      </Button>
    </div>
  </div>
</template>
